module.exports = __webpack_public_path__ + "img/vertical_6_1_8023.8659bbf7.png";